export default __webpack_public_path__ + "static/media/misc-closet2.585885fe.jpg";